import React, { useState, useEffect } from "react";
import styles from "./CommerceAISection.module.scss";

const CommerceAISection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isClient, setIsClient] = useState(false); // Track if the component has mounted

  useEffect(() => {
    setIsClient(true); // Set to true after the component is mounted
  }, []);

  return (
    <div className={styles["commerce-ai-container"]}>
      <div className={styles["commerce-ai-left"]}>
        {data.map((item, index) => (
          <div
            key={index}
            className={`${styles["commerce-ai-item"]} ${
              index === activeIndex ? styles["active"] : ""
            }`}
            onClick={() => setActiveIndex(index)}
          >
            <h1 className={styles["commerce-ai-item-title"]}>{item.title}</h1>
            {/* Render description only after the component is mounted on the client */}
            {isClient && index === activeIndex && (
              <p className={styles["commerce-ai-item-description"]}>
                {item.description}
              </p>
            )}
          </div>
        ))}
      </div>
      <div className={styles["commerce-ai-right"]}>
        <img
          className={styles["commerce-ai-right-img"]}
          src="/crucial.png"
          alt="commerce-ai"
        />
      </div>
    </div>
  );
};

export default CommerceAISection;

const data = [
  {
    title: "Data Aquisition Engine",
    description:
      "Data acquisition engines automate web scraping, turning data into actionable insights to gather product info, reviews, and market trends efficiently and compliantly.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/serp.webp",
  },
  {
    title: "Digital Shelf API",
    description:
      "Manage and optimize your digital shelf presence across various platforms.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/price-optimization.webp",
  },
  {
    title: "Product Matching API",
    description:
      "Ensure accurate product matching across different marketplaces.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/serp.webp",
  },
  {
    title: "Realtime Crawling API",
    description:
      "Get real-time data crawling capabilities for various eCommerce platforms.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/price-optimization.webp",
  },
  {
    title: "Dynamic Repricing API",
    description:
      "Automatically adjust prices based on market conditions and competition.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/serp.webp",
  },
  {
    title: "Social Media Monitoring API",
    description:
      "Monitor Social Media & Influencer trends across retailers and MSMEs.",
    image:
      "https://ik.imagekit.io/y5xyemmwee7/assets/images/v4/products/price-optimization.webp",
  },
];
